module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp15-cf3168231a09e63b4174d0dc0fd17eea.jpg";